

import Vue from 'vue'
import 'babel-polyfill'
import FastClick from 'fastclick'
import router from './router'
import store from './store/index'
import App from './App'
import Ellipsis from 'ellipsis-plus'
import Null from './components/Null'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import AlertPlugin from 'vux/src/plugins/alert/index.js'

import WechatPlugin from 'vux/src/plugins/wechat/index.js'

import LoadingPlugin from 'vux/src/plugins/loading/index.js'



Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)
Vue.use(AlertPlugin)
Vue.use(WechatPlugin)
Vue.use(LoadingPlugin)



Vue.prototype.$title = function (title) {
document.title = title;
var iframe = document.createElement("iframe");
iframe.style.display = 'none';
var loadedCallback = () => {
iframe.removeEventListener('load', loadedCallback);
document.body.removeChild(iframe);
};
iframe.addEventListener('load', loadedCallback);
document.body.appendChild(iframe);
};

Vue.component('null', Null)
Vue.component(Ellipsis.name, Ellipsis)

FastClick.attach(document.body)


Vue.config.productionTip = false

router.beforeEach(function (to, from, next) {


if(to.meta.auth){

let {urid} = store.getters.getUserInfo;

if(urid*1===0){
Vue.$vux.confirm.show({
title: '提示',
content:  "当前页面需要登录后才可以操作,立即登录?",
onConfirm() {
Vue.wechat.miniProgram.navigateTo({
url: '../user/userauth'
})
},
onCancel(){
Vue.wechat.miniProgram.switchTab({
url: '../default/index'
})
}
})
return;
}


}


if (to.meta.showloading) {
store.commit('updateLoadingStatus', {isLoading: true})
}
if (to.meta.title) {
document.title = to.meta.title;
}
next();
})

router.afterEach(function (to) {

if (to.meta.showloading) {
setTimeout(function () {
store.commit('updateLoadingStatus', {isLoading: false})
}, 200)
}


})

Date.prototype.format = function(fmt) {
var o = {
"M+" : this.getMonth()+1,                 //月份
"d+" : this.getDate(),                    //日
"h+" : this.getHours(),                   //小时
"m+" : this.getMinutes(),                 //分
"s+" : this.getSeconds(),                 //秒
"q+" : Math.floor((this.getMonth()+3)/3), //季度
"S"  : this.getMilliseconds()             //毫秒
};
if(/(y+)/.test(fmt)) {
fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
}
for(var k in o) {
if(new RegExp("("+ k +")").test(fmt)){
fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
}
}
return fmt;
}






/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js